<template>
<div>
    <section style="margin: 1em;" v-if="$root.env.loading.users">
        <b-progress :value="progress" show-value type="is-primary">
            {{$root.users.length}} / {{$root.event.counter.recipients}}
        </b-progress>
    </section>
    <section>
        <b-field  label="Gewähltes Event" horizontal>
            <b-select placeholder="" v-model="eventToRegister" expanded>
                <option v-for="day in niceEvents" :value="day">{{day.name}}</option>
                <option v-for="event in $root.event.workshops" :value="event">{{event.name}}</option>
            </b-select>
        </b-field>

        <b-field  position="is-right">
            <b-input placeholder="Search..." type="search" icon="search" v-model="search">
            </b-input>
            <p class="control" v-if="eventToRegister !== ''">
                <b-button type="is-primary" icon-right="qrcode" icon-pack="fal" @click="scannerToggle = true" />
            </p>
            <p class="control">
                <b-button type="is-info" icon-pack="far" icon-right="sync-alt" :loading="$root.env.loading.users" :disabled="$root.env.loading.users"
                          @click="$root.getUsers($route.params.id)"></b-button>
            </p>
        </b-field>
        <b-table :data="filtered" :row-class="(o,n) => o.id == search ? 'trHighlight' : ''"
                 paginated per-page="25">
            <template slot-scope="props">
                <b-table-column field="id" label="ID" width="40" numeric>
                    {{ props.row.id }}
                </b-table-column>
                <b-table-column v-for="col in columns" :field="'field_'+col.id" :label="col.name" sortable>
                    <span v-html="$options.filters.emphSearch(props.row['field_'+col.id], search)"></span>
                </b-table-column>
                <b-table-column field="field_1" label="e-Mail">
                    <span v-html="$options.filters.emphSearch(props.row.field_1, search)"></span>
                </b-table-column>
                <b-table-column field="data.checkin" label="eingecheckt?" :visible="eventToRegister !== ''">
                    <b-field>
                        <b-checkbox v-model="props.row.data.checkin['workshop_'+eventToRegister.id+'_checkin']" @input="$root.saveUser(props.row.id,props.row.data)">

                        </b-checkbox>
                    </b-field>
                </b-table-column>
            </template>
            <template slot="empty" v-if="$root.env.loading.users === false">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon icon="frown" pack="fal" size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>
        </b-table>
    </section>
    <b-modal :active.sync="scannerToggle" v-if="eventToRegister !== ''">
        <p>
            <qrcode-stream @decode="onDecode">
                <div class="qrOverlay">
                    Bitte QR-Code aus der Einladung scannen.
                </div>
            </qrcode-stream>
        </p>
    </b-modal>
</div>
</template>

<script>
export default {
    name: 'Registration',
    props: {

    },
    data() {
        return {
            search: '',
            eventToRegister: '',
            scannerToggle: false
        }
    },
    methods: {
        update(id = this.$route.params.id) {
            //this.$root.getUsers(id)
            return true
        },
        onDecode(decodedString) {
            console.log(decodedString)
            let info = {},user, error = false
            info.data = decodedString.split('/')
            info.i = info.data.length
            try {
                // if(info.data[info.i-3] != this.$root.event.slug){
                //         throw "slug";
                //     }

                    user = this.$root.users.find(us => us.id == info.data[info.i-2])
                    user.data.checkin['workshop_'+this.eventToRegister.id+'_checkin'] = true

                    this.$root.saveUser(user.id,user.data)

                    this.search = info.data[info.i-2]

            }
            catch (e) {
               // Anweisungen für jeden Fehler
            //    logMyErrors(e); // Fehler-Objekt an die Error-Funktion geben
               this.$buefy.toast.open({
                          message: 'QR-Code fehlerhaft',
                          type: 'is-danger'
                      })
            }


          this.scannerToggle = false
            return
        }
    },
    filters: {
        emphSearch: function (value, search) {
            if (!value) return ''
            if (search == '') return value
            if (search.length < 3) return value
            value = value.toString();
            const hashReg = new RegExp(search, "i");
            value = value.replace(hashReg, "<b>$&</b>");
            return value;
        }
    },
    created() {
        // fetch the data when the view is created and the data is
        // already being observed

        this.update()
    },
    computed: {
        progress(){
            if(this.$root.users.length === 0) return undefined;

            return (100 * this.$root.users.length / this.$root.event.counter.recipients)
        },
        niceEvents: function () {
            let r = {
                days: [],
                events: {},
                eventIds : {}
            }
            let ret = []
            this.$root.event.workshops.forEach(w => {
                if (!r.events[w.date]) {
                    r.events[w.date] = {}
                    r.days.push(w.date)
                }
                if (!r.eventIds[w.date]) r.eventIds[w.date] = []
                r.eventIds[w.date].push(w.id)
            })
            r.days.sort()
            r.first = r.days[0]
            r.last = r.days[r.days.length - 1]
            r.equal = r.first === r.last
            if(r.equal){
                ret.push({
                    id: 'global',
                    name: 'Gesamte Veranstaltung ('+ this.$moment(r.days[0], 'YYYY-MM-DD').format('ddd, D. MMM YY') +')'
                })
            }else{
                ret.push({
                    id: 'global',
                    name: 'Gesamte Veranstaltung ('+ this.$moment(r.days[0], 'YYYY-MM-DD').format('ddd, D. MMM YY') +' - '+ this.$moment(r.days[r.days.length - 1], 'YYYY-MM-DD').format('ddd, D. MMM YY') +')'
                })
                r.days.forEach((d,index) => {
                    ret.push({
                        id: r.days[index].replace(/[^0-9]/g, ''),
                        name: (index+1)+'. Veranstaltungstag ('+ this.$moment(r.days[index], 'YYYY-MM-DD').format('ddd, D. MMM YY') +')',
                        type: 'global',
                        value: r.days[index],
                        events: r.eventIds[r.days[index]]
                    })
                })
            }
            return ret
        },
        columns(){
            if(this.$root.event.fields.table) return this.$root.env.account.fields.filtered.filter(e => this.$root.event.fields.table.includes(e.id))
            return []
        },
        filtered() {
            let origin = this.$root.users,
                filtered = [],
                isId = false,
                patt = new RegExp(this.search, "i"),
                pattid = new RegExp('^('+this.search+')$', "i");
            origin = origin.filter(user => user.data._attending === 'yes')
            if(typeof this.eventToRegister === 'object' && this.eventToRegister.id !== 'global' && this.eventToRegister.mandatory !== true){
                origin = origin.filter(user => {
                    if(this.eventToRegister.type === 'global'){
                        let found = false
                        this.niceEvents.find(e => e.id === this.eventToRegister.id).events.forEach(e => {
                            found = user.data.workshops['workshop_' + e + '_registered'] === true ? true : found
                        })
                        return found
                    }
                    if(this.eventToRegister.mandatory !== true){
                        return user.data.workshops['workshop_' + this.eventToRegister.id + '_registered'] === true
                    }
                    return true
                })
            }
            if (this.search == '') {
                return origin
            }
            origin.forEach(entry => {
                if (pattid.test(entry.id)) {
                    filtered.push(entry)
                    isId = true
                    return
                }
            })
            if (isId) {
                return filtered
            }
            if (this.search.length < 3) {
                return origin
            }
            origin.forEach(entry => {
                if (patt.test(entry.field_1)) {
                    filtered.push(entry)
                    return
                }
                if (patt.test(entry.field_1)) {
                    filtered.push(entry)
                    return
                }
                if (patt.test(entry.field_3)) {
                    filtered.push(entry)
                    return
                }
                if (patt.test(entry.field_4)) {
                    filtered.push(entry)
                    return
                }
            })
            return filtered
        }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.qrOverlay {
    position: absolute;
    width: 100%;
    height: 100%;
    color: #ffffff;
    font-size: 1.5em;
    padding: 1em;
    text-align: center;
}
</style>
<style>

.trHighlight{
    background: linear-gradient(90deg, rgba(35,209,96,1) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 70%, rgba(35,209,96,1) 100%) !important;
}
</style>
